import axiosNode from "@/plugins/axios_node";
export default {
  namespaced: true,
  state: {
    listTeacher: null,
    listTeacherAll: null,
    checkTeacher: null,
    leave_last_tea: null,
  },
  getters: {
    _listTeacher: (state) => state.listTeacher,
    _listTeacherAll: (state) => state.listTeacherAll,
    _checkTeacher: (state) => state.checkTeacher,
    leave_last_tea: (state) => state.leave_last_tea,
  },
  mutations: {},
  actions: {
    _listTeacher({ state }, params) {
      window.axios
        .post("teacher/_listTeacher", params)
        .then((res) => (state.listTeacher = res.data));
    },
    _listTeacherAll({ state }, params) {
      return window.axios
        .post("teacher/_listTeacherAll", params)
        .then((res) => {
          state.listTeacherAll = res.data;
          return res.data;
        });
    },
    _regis_teacher({ state }, params) {
      return window.axios
        .post("teacher/_regis_teacher", params)
        .then((res) => res.data);
    },
    _checkTeacher({ state }, params) {
      return window.axios.post("teacher/_checkTeacher", params).then((res) => {
        state.checkTeacher = res.data;
        return res.data;
      });
    },
    _checkTeacherFormWeb({ state }, params) {
      return window.axios
        .post("teacher/_checkTeacherFormWeb", params)
        .then((res) => res.data);
    },
    leave_last_tea({ state }, params) {
      // console.log("params In Store:", params);
      return (
        axiosNode
          .post("teacher/leave_last_tea", params)
          // .post("callcenter/checkUser", params)
          .then((res) => {
            state.leave_last_tea = res.data;
            return res.data;
          })
      );
    },
    static_leave_tea({ state }, params) {
      // console.log("params In Store:", params);
      return (
        axiosNode
          .post("teacher/static_leave_tea", params)
          // .post("callcenter/checkUser", params)
          .then((res) => res.data)
      );
    },
    import_data_arrive({ state }, params) {
      console.log("params In Store:", params);
      return (
        axiosNode
          .post("teacher/import_data_arrive", params)
          // .post("callcenter/checkUser", params)
          .then((res) => res.data)
      );
    },
    report_leave_tea({ state }, params) {
      // console.log("params In Store:", params);
      return (
        axiosNode
          .post("teacher/report_leave_tea", params, {
            headers: {
              "Content-Type": "multipart/form-data", // ❌ อย่าทำแบบนี้!
              // ✅ ให้ Axios ตั้งค่าให้เองโดยอัตโนมัติ
            },
          })
          // .post("callcenter/checkUser", params)
          .then((res) => res.data)
      );
    },
  },
};
